export const cache: Record<string, any> = {};
